export class ArrendatarioModel {
    fechaInicio: string;
    fechaFin: string;
    idDocumento: string;
    filiacion: string;
  }
